import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer-new",
  id: "kt_footer"
}
const _hoisted_2 = { class: "footer-inner" }
const _hoisted_3 = { class: "footer-logo" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "footer-copy" }, "TenantHub Pty Ltd © 2023", -1)
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<ul class=\"menu footer-menu\"><li class=\"menu-item\"><a href=\"#\" target=\"_blank\" class=\"menu-link px-2\">About</a></li><li class=\"menu-item\"><a href=\"#\" target=\"_blank\" class=\"menu-link px-2\">Support</a></li></ul>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainLogo = _resolveComponent("MainLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MainLogo, { class: "footer-logo-image" }),
        _hoisted_4
      ]),
      _hoisted_5
    ])
  ]))
}